import * as React from 'react';

import { Breadcrumbs } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type Props = {
  orgSlug: string;
  orgName: string;
};

const EnterpriseOrgScopedLearningPathBreadcrumbs = ({ orgSlug, orgName }: Props) => {
  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href={`/organizations/${orgSlug}`}>{_t('All learning programs')}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={`/organizations/${orgSlug}`}>{orgName}</Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default EnterpriseOrgScopedLearningPathBreadcrumbs;
